export default __webpack_public_path__ + "static/media/about-1.9379fe59.png";